import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import Format from '../utils/format';
import moment from 'moment';

class itemStore {

    // PROPERTIES

    // General Properties

    @observable pageTitle = undefined;

    // Task Properties

    @observable taskId = undefined;

    @observable taskName = '';
    @observable taskNameEnglish = undefined;
    @observable taskNameChinese = undefined;
    @observable taskNameChineseTraditional = undefined;
    @observable taskNameThai = undefined;
    @observable taskNameJapanese = undefined;
    @observable taskNameVietnamese = undefined;

    @observable taskDesc = '';
    @observable taskDescEnglish = '';
    @observable taskDescChinese = '';
    @observable taskDescChineseTraditional = '';
    @observable taskDescThai = '';
    @observable taskDescJapanese = '';
    @observable taskDescVietnamese = '';

    @observable parentId = undefined;
    @observable parentName = undefined;

    @observable departmentID = undefined;
    @observable departments = [];

    @observable defaultToUserType = undefined;
    @observable defaultToUserTypes = [];

    @observable stock = 1;
    @observable minimumStock = 1;
    @observable requestLimit = 1;
    @observable dailyRequestLimit = 0;
    @observable price = 0;
    @observable imageUrl = '';
    @observable lastTaskName = '';
    
    @observable startTime = null;
    @observable endTime = null;

    @observable sortID = 0;

    @observable itemHasStock = false;

    // Helper Properties

    @observable isLastChild = false;
    @observable isSubCategory = false;

    @observable itemLoading = false;
    @observable toastText = '';

    @observable selectedItemTree = [];
    @observable expandedItemTree = [];

    @observable readItemSuccess = true;

    // Initialization

    @action initUpdateItem() {
        this.getTaskByTaskName('StayMenu');
    }

    @action initCreateItem() {
        this.pageTitle = 'Create Item';

        this.parentId = this.taskId;
        this.parentName = this.taskName;
        this.taskId = 0;
        this.taskName = '';
        this.taskDesc = '';

        this.taskNameEnglish = '';
        this.taskNameChinese = '';
        this.taskNameChineseTraditional = '';
        this.taskNameThai = '';
        this.taskNameJapanese = '';
        this.taskNameVietnamese = '';

        this.taskDescEnglish = '';
        this.taskDescChinese = '';
        this.taskDescChineseTraditional = '';
        this.taskDescThai = '';
        this.taskDescJapanese = '';
        this.taskDescVietnamese = '';

        this.imageUrl = '';
        this.stock = 1;
        this.minimumStock = 1;
        this.requestLimit = 1;
        this.dailyRequestLimit = 1;
        this.price = 0;
        this.itemHasStock = this.minimumStock > 0;

        this.startTime = null;
        this.endTime = null;

        this.sortID = 9999;

        this.isSubCategory = false;
        this.isLastChild = true;
    }

    // TRANSACTION

    @action createTask() {
        this.toastText = 'Creating item';
        this.itemLoading = true;

        if (this.isSubCategory) {
            this.nextCount = 1;
        } else {
            this.nextCount = 0;
        }

        let startTime = null;
        let endTime = null;

        if (this.startTime) {
            startTime = moment(this.startTime).format('HH:mm:00');
        }

        if (this.endTime) {
            endTime = moment(this.endTime).format('HH:mm:00');
        }

        if (startTime === null || endTime === null) {
            startTime = null;
            endTime = null;
        }

        if (!this.itemHasStock) {
            this.minimumStock = 0;
        } else {
            if (this.minimumStock === 0) {
                this.minimumStock = 1;
            }
        }

        return ApiCaller.Item.apiCreateItem(
            this.departmentID, this.defaultToUserType,
            this.taskName,
            this.taskNameEnglish, this.taskNameChinese, this.taskNameChineseTraditional, this.taskNameThai, this.taskNameJapanese, this.taskNameVietnamese,
            this.taskDescEnglish, this.taskDescChinese, this.taskDescChineseTraditional, this.taskDescThai, this.taskDescJapanese, this.taskDescVietnamese,
            this.imageUrl, this.parentId, this.stock, this.minimumStock, this.requestLimit, this.dailyRequestLimit, this.price, this.nextCount,
            startTime, endTime, this.sortID)
            .then((response) => {
                if (response) {
                    if (response.isError) {
                        this.itemLoading = false;
                        return response;
                    }

                    this.selectedItemTree = [response.taskName];

                    this.itemLoading = false;
                    this.getTaskByTaskName(response.taskName);
                } else {
                    this.itemLoading = false;
                }
            })
    }

    @action updateTask() {
        this.toastText = 'Updating item';
        this.itemLoading = true;

        let startTime = null;
        let endTime = null;

        if (this.startTime) {
            startTime = moment(this.startTime).format('HH:mm:00');
        }

        if (this.endTime) {
            endTime = moment(this.endTime).format('HH:mm:00');
        }

        if (startTime === null || endTime === null) {
            startTime = null;
            endTime = null;
        }

        if (!this.itemHasStock) {
            this.minimumStock = 0;
        } else {
            if (this.minimumStock === 0) {
                this.minimumStock = 1;
            }
        }

        return ApiCaller.Item.apiUpdateItem(
            this.taskId, this.departmentID, this.defaultToUserType,
            this.taskName,
            this.taskNameEnglish, this.taskNameChinese, this.taskNameChineseTraditional, this.taskNameThai, this.taskNameJapanese, this.taskNameVietnamese,
            this.taskDescEnglish, this.taskDescChinese, this.taskDescChineseTraditional, this.taskDescThai, this.taskDescJapanese, this.taskDescVietnamese,
            this.imageUrl, this.parentId, this.stock, this.minimumStock, this.requestLimit, this.dailyRequestLimit, this.price,
            startTime, endTime, this.sortID)
            .then((response) => {
                if (response) {
                    if (response.isError) {
                        this.itemLoading = false;
                        return response;
                    }

                    this.selectedItemTree = [response.taskName];

                    this.itemLoading = false;
                    this.getTaskByTaskName(response.taskName);
                } else {
                    this.itemLoading = false;
                }
            })
    }

    @action deleteTask() {
        this.toastText = 'Deleting item';
        this.itemLoading = true;

        return ApiCaller.Item.apiDeleteItem(this.taskId).then((itemResponse) => {
            if (itemResponse) {
                if (itemResponse.isError) {
                    return itemResponse;
                }

                this.selectedItemTree = [this.parentName];

                this.itemLoading = false;
                this.getTaskByTaskName(this.parentName);
            } else {
                this.itemLoading = false;
            }
        })
    }

    @action refreshTask() {
        this.toastText = 'Refreshing item';
        this.itemLoading = true;

        return ApiCaller.Redis.apiGetLatestRedis().then((refreshTaskResponse) => {
            this.itemLoading = false;

            this.initUpdateItem();
            return refreshTaskResponse;
        })
    }

    @action cancelCreateTask() {
        this.getTaskByTaskName(this.lastTaskName);
    }

    // GET Properties

    @action getTaskByTaskName(taskName) {
        this.toastText = 'Loading item';
        this.itemLoading = true;

        return ApiCaller.Item.apiGetItemByItemName(taskName).then((response) => {
            if (response) {
                this.readItemSuccess = true;

                if (!response.taskDesc) {
                    response.taskDesc = '';
                }

                this.pageTitle = taskName;
                this.taskId = response.taskId;
                this.departmentID = response.departmentID;
                this.defaultToUserType = response.defaultToUserType;
                this.taskName = response.taskName;
                this.taskDesc = response.taskDesc;
                this.lastTaskName = this.taskName;

                if (response.taskNameLang) {
                    if (response.taskNameLang.english === '') {
                        this.taskNameEnglish = response.taskName;
                    } else {
                        this.taskNameEnglish = response.taskNameLang.english;
                    }

                    if (response.taskNameLang.chinese === '') {
                        this.taskNameChinese = response.taskName;
                    } else {
                        this.taskNameChinese = response.taskNameLang.chinese;
                    }

                    if (response.taskNameLang.chineseTraditional === '') {
                        this.taskNameChineseTraditional = response.taskName;
                    } else {
                        this.taskNameChineseTraditional = response.taskNameLang.chineseTraditional;
                    }

                    if (response.taskNameLang.thai === '') {
                        this.taskNameThai = response.taskName;
                    } else {
                        this.taskNameThai = response.taskNameLang.thai;
                    }

                    if (response.taskNameLang.japanese === '') {
                        this.taskNameJapanese = response.taskName;
                    } else {
                        this.taskNameJapanese = response.taskNameLang.japanese;
                    }

                    if (response.taskNameLang.vietnamese === '') {
                        this.taskNameVietnamese = response.taskName;
                    } else {
                        this.taskNameVietnamese = response.taskNameLang.vietnamese;
                    }
                } else {
                    this.taskNameEnglish = response.taskName;
                    this.taskNameChinese = response.taskName;
                    this.taskNameChineseTraditional = response.taskName;
                    this.taskNameThai = response.taskName;
                    this.taskNameJapanese = response.taskName;
                    this.taskNameVietnamese = response.taskName;
                }

                if (response.taskDescLang) {
                    if (response.taskDescLang.english === '' || response.taskDescLang.english === null) {
                        this.taskDescEnglish = response.taskDesc;
                    } else {
                        this.taskDescEnglish = response.taskDescLang.english;
                    }

                    if (response.taskDescLang.chinese === '' || response.taskDescLang.chinese === null) {
                        this.taskDescChinese = response.taskDesc;
                    } else {
                        this.taskDescChinese = response.taskDescLang.chinese;
                    }

                    if (response.taskDescLang.chineseTraditional === '' || response.taskDescLang.chineseTraditional === null) {
                        this.taskDescChineseTraditional = response.taskDesc;
                    } else {
                        this.taskDescChineseTraditional = response.taskDescLang.chineseTraditional;
                    }

                    if (response.taskDescLang.thai === '' || response.taskDescLang.thai === null) {
                        this.taskDescThai = response.taskDesc;
                    } else {
                        this.taskDescThai = response.taskDescLang.thai;
                    }

                    if (response.taskDescLang.japanese === '' || response.taskDescLang.japanese === null) {
                        this.taskDescJapanese = response.taskDesc;
                    } else {
                        this.taskDescJapanese = response.taskDescLang.japanese;
                    }

                    if (response.taskDescLang.vietnamese === '' || response.taskDescLang.vietnamese === null) {
                        this.taskDescVietnamese = response.taskDesc;
                    } else {
                        this.taskDescVietnamese = response.taskDescLang.vietnamese;
                    }
                } else {
                    this.taskDescEnglish = response.taskDesc;
                    this.taskDescChinese = response.taskDesc;
                    this.taskDescChineseTraditional = response.taskDesc;
                    this.taskDescThai = response.taskDesc;
                    this.taskDescJapanese = response.taskDesc;
                    this.taskDescVietnamese = response.taskDesc;
                }

                this.imageUrl = response.imageUrl || '';
                this.parentName = response.parentName;
                this.parentId = response.parentId;
                this.stock = response.total;
                this.minimumStock = response.minimumStock;
                this.requestLimit = response.requestLimit;
                this.dailyRequestLimit = response.dailyRequestLimit;
                this.price = response.price;
                this.sortID = response.sortID;
                this.itemHasStock = this.minimumStock > 0;

                if (response.startTime === null || response.startTime === '') {
                    this.startTime = null;
                } else {
                    this.startTime = moment(`${moment().format('YYYY-MM-DD')} ${response.startTime}`);
                }

                if (response.endTime === null || response.endTime === '') {
                    this.endTime = null;
                } else {
                    this.endTime = moment(`${moment().format('YYYY-MM-DD')} ${response.endTime}`);
                }

                if (response.nextCount === 0) {
                    this.isLastChild = true;
                } else {
                    this.isLastChild = false;
                }

                ApiCaller.Department.apiGetDepartments().then((departmentResponse) => {
                    this.departments = [];
                    if (departmentResponse) {
                        this.departments = departmentResponse;
                    };

                    ApiCaller.AssignRoleItem.apiGetAssignRoleItem().then((assignRoleItemResponse) => {
                        this.defaultToUserTypes = [];
                        if (assignRoleItemResponse) {
                            this.defaultToUserTypes = assignRoleItemResponse;
                        }
                    });
                })

                this.itemLoading = false;
            } else {
                this.pageTitle = 'An unexpected issue occured. Please contact your system administrator or click Refresh Item button.';
                this.readItemSuccess = false;
                this.itemLoading = false;
            }
        })
    }

    // SET Properties

    @action setTaskName(value) {
        this.taskName = Format.RemoveSpecialChars2(value);
    }

    @action setTaskNameEnglish(value) {
        this.taskNameEnglish = value;
    }

    @action setTaskNameChinese(value) {
        this.taskNameChinese = value;
    }

    @action setTaskNameChineseTraditional(value) {
        this.taskNameChineseTraditional = value;
    }

    @action setTaskNameThai(value) {
        this.taskNameThai = value;
    }

    @action setTaskNameJapanese(value) {
        this.taskNameJapanese = value;
    }

    @action setTaskNameVietnamese(value) {
        this.taskNameVietnamese = value;
    }

    @action setTaskDescEnglish(value) {
        this.taskDescEnglish = value;
        this.taskDesc = value;
    }

    @action setTaskDescChinese(value) {
        this.taskDescChinese = value;
    }

    @action setTaskDescChineseTraditional(value) {
        this.taskDescChineseTraditional = value;
    }

    @action setTaskDescThai(value) {
        this.taskDescThai = value;
    }

    @action setTaskDescJapanese(value) {
        this.taskDescJapanese = value;
    }

    @action setTaskDescVietnamese(value) {
        this.taskDescVietnamese = value;
    }

    @action setImageUrl(value) {
        this.imageUrl = value;
    }

    @action setDepartmentID(value) {
        this.departmentID = value;
    }

    @action setDefaultToUserType(value) {
        this.defaultToUserType = value;
    }

    @action setStock(value) {
        this.stock = value;
    }

    @action setMinimumStock(value) {
        this.minimumStock = value;
    }

    @action setRequestLimit(value) {
        this.requestLimit = value;
    }

    @action setDailyRequestLimit(value) {
        this.dailyRequestLimit = value;
    }

    @action setPrice(value) {
        this.price = value;
    }

    @action setStartTime(value) {
        if (value) {
            this.startTime = value;
        } else {
            this.startTime = null;
        }
    }

    @action setEndTime(value) {
        if (value) {
            this.endTime = value;
        } else {
            this.endTime = null;
        }
    }

    @action setSortID(value) {
        this.sortID = value;
    }

    @action setItemHasStock(value) {
        this.itemHasStock = value;
    }

    @action setIsLastChild(value) {
        this.isLastChild = value;
    }

    @action setItemLoading(value) {
        this.itemLoading = value;
    }

    @action setIsSubCategory(value) {
        this.isSubCategory = value;
        this.isLastChild = !value;
    }

    @action setSelectedItemTree(value) {
        this.selectedItemTree = value;
    }

    @action setExpandedItemTree(value) {
        this.expandedItemTree = value;
    }
}

export default new itemStore()